module.exports = __webpack_public_path__ + "media/images/athletes/1987-eb168959ec6f3344ab0a0149974e3fcc.png";